import { createAction, type Dispatch, type ThunkAction, type AnyAction } from '@reduxjs/toolkit';
import { api } from '@/lib/trpc/client';
import type { RootState } from '@/app/store';
import type { Assortment } from '@/server/assortments/assortments';
import { TRPCClientError } from '@trpc/client';

export const assortmentsRequestStarted = createAction('assortments/request/started');
export const assortmentsRequestFailed = createAction<string>('assortments/request/failed');

export const fetchAssortmentsSucceeded = createAction<{ assortments: Assortment[] }>(
  'assortments/fetch/succeeded'
);
export const fetchAssortments =
  (chain?: string): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(assortmentsRequestStarted());

    const state = getState();
    const activeChain = chain ?? state.user.activeChain;

    const assortmentsSearchState = state.assortmentsSearch;
    const { activeFilters } = assortmentsSearchState;

    // check if brand is object or string and change to string
    if (typeof activeFilters.brand === 'object') {
      console.error('Brand filter is an object:', activeFilters.brand);
    }

    return api.assortments.getAssortmentList
      .query({
        chain: activeChain,
        filters: activeFilters,
      })
      .then(
        (data) => {
          dispatch(fetchAssortmentsSucceeded({ assortments: data }));
        },
        (error: unknown) => {
          let message = 'Error while fetching assortments';

          if (error instanceof TRPCClientError) {
            message = error.message;
          }

          dispatch(assortmentsRequestFailed(message));
        }
      );
  };
